<template>
  <p class="introduction">
    <slot/>
  </p>
</template>

<script>
export default {
  name: 'CIntroduction'
}
</script>

<style scoped>
.introduction {
  margin-bottom: var(--grid-spacing);

  font-size: calc(16px + 0.15vmin);
  font-style: italic;
}
</style>
